var _rect, _path, _g, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 54 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 36,
    fill: "#002b7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,22.5H54V27H0z",
    fill: "#f9e814"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12,8v4h2z",
    transform: "rotate(18,12,8)",
    id: "o"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    x: -24,
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(72,12,12)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(-72,12,12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "rotate(144,12,12)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -4,
    y: -4,
    transform: "scale(0.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/cw.40e4f5005615c2125016c82ecdd719f7.svg";
export { ForwardRef as ReactComponent };